export default __webpack_public_path__ + "static/media/video_icon.2ac88c4c.svg";